import { Box, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Tabs from '../../components/tabs';
import ContactInformation from './components/contact-information';
import { ProfileTabs } from './utils';
import { TabItem } from '../../components/tabs/types';
import { useGetProfileQuery } from './api/profileApi';
import PasswordChange from './components/password-change';
import PageWrapper from '../../components/page-wrapper';

const Profile = () => {
    const { t } = useTranslation();
    const { data: user, error, isLoading } = useGetProfileQuery();

    const tabs: Array<TabItem> = [
        { id: ProfileTabs.CONTACT_INFORMATION, label: t('contact-information').toUpperCase() },
        { id: ProfileTabs.PASSWORD_RESET, label: t('password-management').toUpperCase() },
    ];

    const [activeTab, setActiveTab] = useState<TabItem>(tabs[0]);
    const handleTabChange = (tab: TabItem) => {
        setActiveTab(tab);
    };

    const renderActiveTabContent = () => {
        if (isLoading) {
            return null;
        }
        if (error || !user) {
            return <Typography color='common.system.error.main'>{t('error-profile-loading')}</Typography>;
        }

        switch (activeTab.id) {
            case ProfileTabs.CONTACT_INFORMATION:
                return <ContactInformation user={user} />;
            case ProfileTabs.PASSWORD_RESET:
                return <PasswordChange />;
        }
    };

    return (
        <PageWrapper title={t('user-profile')}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px', marginTop: '32px' }}>
                <Tabs tabs={tabs} activeTab={activeTab} onTabChange={handleTabChange} ariaLabel={t('profile-tabs')} />
                {renderActiveTabContent()}
            </Box>
        </PageWrapper>
    );
};

export default Profile;
